<div class="e-shell-layout" *ngIf="isAuthenticated">
    <div class="e-header-nav">
        <via-header-nav [menuItems]="menuItems"></via-header-nav>
    </div>
    <div class="e-content">
        <router-outlet></router-outlet>
    </div>
    <div class="e-footer">
        <via-footer></via-footer>
    </div>
</div>
